import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";
import { ImportarExcelProveedores } from "./ImportarExcelProveedores";

export function ProveedoresHeader({
  total,
  activos,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  activos: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Proveedores"
      description={`Catálogo · ${total} total · ${activos} activo(s) · varios proveedores pueden compartir RFC (decisión 44).`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          <ImportarExcelProveedores />
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo proveedor
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
